import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import generateUtilityClass from '@mui/utils/generateUtilityClass';

export const COMPONENT_NAME = 'CaroteneTile';

export interface TileClasses {
    root: string;
    colorPrimary: string;
    colorSecondary: string;
    colorError: string;
    colorInfo: string;
    colorSuccess: string;
}

export type TileClassKey = keyof TileClasses;

export function getTileUtilityClass(slot: string): string {
    return generateUtilityClass(COMPONENT_NAME, slot);
}

export const tileClasses: TileClasses = generateUtilityClasses(COMPONENT_NAME, [
    'root',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
]);
